export default __webpack_public_path__ + "images/0xc5e2b037d30a390e62180970b3aa4e91868764cd.png";